<mat-card class="despacho-content m-4">
  <mat-card-content class="imprimir-container">
    <h1 class="!mb-4" style="font-size: 20px; font-weight: 500;">ACUERDO MR. B.</h1>
  </mat-card-content>
  <mat-card-content>
    <mat-card appearance="outlined">
      <mat-card-content>
        <form [formGroup]="nuevoAcuerdo" class="w-full">
          <h2 class="!mt-3">Nuevo Acuerdo</h2>

          <section
            class="!grid !grid-cols-3 !gap-3 !items-center content-center">
            <mat-form-field>
              <mat-datepicker-toggle
                matIconPrefix
                [for]="picker"></mat-datepicker-toggle>

              <input
                formControlName="fechaAcuerdo"
                name="fechaAcuerdo"
                matInput
                [matDatepicker]="picker" />
              <mat-datepicker #picker></mat-datepicker>
              @if (nuevoAcuerdo.get('fechaAcuerdo')?.invalid &&
              nuevoAcuerdo.get('fechaAcuerdo')?.touched) {
              <mat-error>Campo obligatorio</mat-error>
              }
            </mat-form-field>
            <mat-slide-toggle
              name="banAgregarTema"
              formControlName="banAgregarTema"
              labelPosition="before"
              hideIcon="true"
              class="mb-5 mt-5"
              [color]="'primary'">
              Agregar Tema
            </mat-slide-toggle>
          </section>

          <section *ngIf="nuevoAcuerdo.get('banAgregarTema')?.value">
            <section class="!grid !grid-cols-2 !gap-3">
              <mat-form-field class="w-full">
                <mat-label>Tema</mat-label>
                <input
                  required
                  formControlName="nombreTema"
                  name="nombreTema"
                  class="w-full"
                  type="text"
                  minlength="1"
                  maxlength="1000"
                  matInput
                  placeholder="Tema" />
                <mat-hint align="end"
                  >{{ nuevoAcuerdo.get("nombreTema")?.value.length }} /
                  1000</mat-hint
                >
                @if (nuevoAcuerdo.get('nombreTema')?.invalid &&
                nuevoAcuerdo.get('nombreTema')?.touched) {
                <mat-error>Campo obligatorio</mat-error>
                }
              </mat-form-field>
              <mat-form-field
                class="flex-grow"
                *ngIf="catalogos$ | async as catalogos">
                <mat-label>Tipo</mat-label>
                <mat-select
                  formControlName="tipoTema"
                  name="tipoTema"
                  placeholder="Tipo">
                  @for (tipoTema of catalogos.catTipoTema; track tipoTema) {
                  <mat-option [value]="tipoTema.id">{{
                    tipoTema.descripcion
                  }}</mat-option>
                  }
                </mat-select>
                @if (nuevoAcuerdo.get('tipoTema')?.invalid &&
                nuevoAcuerdo.get('tipoTema')?.touched) {
                <mat-error>Campo obligatorio.</mat-error>
                }
              </mat-form-field>
            </section>

            @if(getContador(nuevoAcuerdo.get("descripcionTema_html")?.value)<=0&&
            nuevoAcuerdo.get("descripcionTema_html")?.touched) {
            <p class="!mt-4 !mb-1 descripcionTema_html_error">Descripción*</p>
            }@else {
            <p class="!mt-4 !mb-1 descripcionTema_html">Descripción*</p>
            }

            <section class="border border-t-gray-300">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
              </ngx-editor-menu>
              <ngx-editor
                [editor]="editor"
                formControlName="descripcionTema_html"
                [placeholder]="'...'"
                height="100px"></ngx-editor>
            </section>

            <section class="!flex !item-end !justify-between !mb-4">
              @if(getContador(nuevoAcuerdo.get("descripcionTema_html")?.value)<=0&&
              nuevoAcuerdo.get("descripcionTema_html")?.touched) {
              <p class="!m-0 descripcionTema_html_error">Campo obligatorio</p>
              }@else {
              <p class0="!m-0 "></p>
              }
              <mat-hint align="end">
                {{
                  getContador(nuevoAcuerdo.get("descripcionTema_html")?.value)
                }}
                / 50000</mat-hint
              >
            </section>

            <section class="!grid !grid-cols-3 !gap-3">
              <mat-slide-toggle
                (change)="confidencialSelected($event)"
                name="esConfidencial"
                formControlName="esConfidencial"
                labelPosition="before"
                hideIcon="true"
                class="mb-5 mt-5"
                [color]="'primary'">
                Confidencial
              </mat-slide-toggle>
              <mat-form-field
                class="flex-grow"
                *ngIf="catalogos$ | async as catalogos">
                <mat-label>Categorización</mat-label>
                <mat-select
                  formControlName="categorizacion"
                  name="categorizacion"
                  placeholder="Categorización">
                  @for (categorizacion of catCategorizacion; track
                  categorizacion) {
                  <mat-option
                      [disabled]="
                    nuevoAcuerdo.get('esConfidencial')?.value
                      ? categorizacion.descripcion == 'C'
                      : categorizacion.descripcion !== 'C'
                  "
                 
                    [value]="categorizacion.id"
                    >{{ categorizacion.descripcion }}-{{
                      categorizacion.descripcionCompleta
                    }}</mat-option
                  >
                  }
                </mat-select>
                @if (nuevoAcuerdo.get('categorizacion')?.invalid &&
                nuevoAcuerdo.get('categorizacion')?.touched) {
                <mat-error>Campo obligatorio.</mat-error>
                }
              </mat-form-field>

              <mat-form-field
                class="flex-grow"
                *ngIf="catalogos$ | async as catalogos">
                <mat-label>Categoría</mat-label>

                <mat-select
                  formControlName="id_categoria"
                  name="id_categoria"
                  placeholder="Categoría">
                  <mat-select-trigger class="trigger-container">
                    <div
                      class="bullet color-{{
                        nuevoAcuerdo.get('id_categoria')?.value
                      }}"></div>
                    <div class="description">
                      {{
                        getCategoriaDescripcion(
                          nuevoAcuerdo.get("id_categoria")?.value,
                          catalogos.catCategoria
                        )
                      }}
                    </div>
                  </mat-select-trigger>
                  <mat-option
                    *ngFor="let cat of catalogos.catCategoria"
                    [value]="cat.id">
                    <div class="option-container">
                      <div class="bullet color-{{ cat.id }}"></div>
                      <div class="description">{{ cat.descripcion }}</div>
                    </div>
                  </mat-option>
                </mat-select>
                @if (nuevoAcuerdo.get('id_categoria')?.invalid &&
                nuevoAcuerdo.get('id_categoria')?.touched) {
                <mat-error>Campo obligatorio.</mat-error>
                }
              </mat-form-field>
            </section>

            <h3 class="!font-bold">Responsables del Tema</h3>
            <section class="!grid !grid-cols-3 !gap-3">
              <mat-form-field
                class="flex-grow"
                *ngIf="catalogos$ | async as catalogos">
                <mat-label>Analista</mat-label>
                <mat-select
                  formControlName="analista"
                  name="analista"
                  placeholder="Analista">
                  @for (analista of catalogos.catAnalista; track analista) {
                  <mat-option [value]="analista">{{
                    analista.nombre
                  }}</mat-option>
                  }
                </mat-select>
                @if (nuevoAcuerdo.get('analista')?.invalid &&
                nuevoAcuerdo.get('analista')?.touched) {
                <mat-error>Campo obligatorio.</mat-error>
                }
              </mat-form-field>
              <mat-form-field
                class="flex-grow"
                *ngIf="catalogos$ | async as catalogos">
                <mat-label>Supervisor</mat-label>
                <mat-select
                  formControlName="supervisor"
                  name="supervisor"
                  placeholder="supervisor">
                  @for (supervisor of catalogos.catSupervisor; track supervisor)
                  {
                  <mat-option [value]="supervisor">{{
                    supervisor.nombre
                  }}</mat-option>
                  }
                </mat-select>
                @if (nuevoAcuerdo.get('supervisor')?.invalid &&
                nuevoAcuerdo.get('supervisor')?.touched) {
                <mat-error>Campo obligatorio.</mat-error>
                }
              </mat-form-field>
              <mat-form-field
                class="flex-grow"
                *ngIf="catalogos$ | async as catalogos">
                <mat-label>Coordinador</mat-label>
                <mat-select
                  formControlName="coordinador"
                  name="coordinador"
                  placeholder="Coordinador">
                  @for (coordinador of catalogos.catCoordinador; track
                  coordinador) {
                  <mat-option [value]="coordinador">{{
                    coordinador.nombre
                  }}</mat-option>
                  }
                </mat-select>
                @if (nuevoAcuerdo.get('coordinador')?.invalid &&
                nuevoAcuerdo.get('coordinador')?.touched) {
                <mat-error>Campo obligatorio.</mat-error>
                }
              </mat-form-field>
            </section>
          </section>
        </form>
        <mat-card-actions align="end" class="nuevo-catalogo-actions">
          <button mat-stroked-button class="!uppercase" (click)="cancelar()">
            Cancelar
          </button>
          <button
            style="white-space: nowrap"
            mat-flat-button
            class="!uppercase"
            color="primary"
            [disabled]="disabled()"
            (click)="guardarAcuerdo()">
            Guardar
          </button>
        </mat-card-actions>
        <p></p>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
